import { defineNuxtPlugin } from 'nuxt/app';
import pino from 'pino';

const severityMapper = {
    info: 'INFO',
    error: 'ERROR',
};

const devLogger = pino({
    level: 'error',
    timestamp: pino.stdTimeFunctions.isoTime,
});

const prodLogger = pino({
    level: 'error',
    timestamp: pino.stdTimeFunctions.isoTime,
});

export default defineNuxtPlugin(() => {
    return {
        provide: {
            logger: (process.env.NODE_ENV === 'development') ? devLogger : prodLogger,
        },
    };
});